import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[cnpjMask]',
})
export class CnpjMaskDirective {
  constructor(private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: any): void {
    if (!event.target.value) {
      return;
    }

    const value = event.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

    const part1 = value.substring(0, 2);
    const part2 = value.substring(2, 5);
    const part3 = value.substring(5, 8);
    const part4 = value.substring(8, 12);
    const part5 = value.substring(12, 14);

    const formattedValue = `${part1}${part2 ? '.' + part2 : ''}${
      part3 ? '.' + part3 : ''
    }${part4 ? '/' + part4 : ''}${part5 ? '-' + part5 : ''}`;

    this.control.control?.setValue(formattedValue, { emitEvent: false });
  }
}
